import * as React from 'react';
import { ContentWrapper } from '../../components/ContentWrapper';
import { Form } from '../../components/Form';
import { LandingBlock } from '../../components/LandingBlock';
import { IShowcase } from '../../types/showcase/props';
import { ISuburbanMortgageDataOptions } from '../../types/suburban/data';
import { SuburbanBlockHeader } from '../SuburbanBlockHeader/SuburbanBlockHeader';
import { SuburbanMortgageAdvantages } from '../SuburbanMortgageAdvantages/SuburbanMortgageAdvantages';

import * as styles from './styles.css';
import { trackSubmitForm } from './tracking';

interface ISuburbanShowcase extends IShowcase {
  data: ISuburbanMortgageDataOptions;
}

export const SuburbanShowcase: React.FC<ISuburbanShowcase> = ({
  formTitle,
  buttonTitle,
  error,
  loading,
  phone,
  submitPhone,
  setPhone,
  setOpen,
  data,
}) => {
  const handleSubmit = React.useCallback(() => {
    trackSubmitForm();
    submitPhone();
  }, [submitPhone]);

  return (
    <LandingBlock>
      <ContentWrapper>
        <div className={styles['container']}>
          <div className={styles['content']}>
            <SuburbanBlockHeader>
              Ипотека на&nbsp;участки, таунхаусы, дома и&nbsp;их&nbsp;строительство
            </SuburbanBlockHeader>
            <SuburbanMortgageAdvantages options={data} />
          </div>
          <div className={styles['form']}>
            <Form
              formTitle={formTitle}
              buttonTitle={buttonTitle}
              error={error}
              loading={loading}
              phone={phone}
              submitPhone={handleSubmit}
              setPhone={setPhone}
              setOpen={setOpen}
            />
          </div>
        </div>
      </ContentWrapper>
    </LandingBlock>
  );
};
